import { defineStore } from "pinia";
import { Network } from "@capacitor/network";

export const useSystemStore = defineStore("system", {
  state: () => ({
    isLoaded: false,

    network_ready: null,
    network_listener: null,
    network_status: {
      connected: false,
      connectionType: "unknown",
    },
  }),
  getters: {
    ready: (state) => state.isLoaded,
  },
  actions: {
    setLoaded(isLoaded) {
      this.isLoaded = isLoaded;
    },

    // Network Actions
    setNetworkStatus(status) {
      this.network_ready = true;
      this.network_status = status;
    },
    async loadNetworkStatus() {
      const status = await Network.getStatus();
      this.setNetworkStatus(status);
      return status;
    },
    addNetworkStatusListener() {
      if (this.network_listener !== null) {
        return Network.removeAllListeners();
      }
      this.network_listener = Network.addListener("networkStatusChange", () =>
        this.loadNetworkStatus()
      );
      return this.network_listener;
    },
    removeNetworkStatusListener() {
      const req = Network.removeAllListeners();
      this.network_listener = null;
      return req;
    },
  },
});
